import { BenefitsSummary } from './types';
import { NavigateFunction } from 'react-router-dom';
import { getCookie } from './cookieUtils';
import config from '../configs/config';

export type TutuCampaign = 'acc_dashboard' | 'nav_link' | 'credit_declined';

/** Tutu guarantor loan site link, tagged with the Afforda campaign that sent the customer. */
export const getTutuUrl = (campaign: TutuCampaign): string =>
  `${config.TUTU_URL}&utm_campaign=${campaign}`;

export const getLoansPath = (): string => {
  const directApply = getCookie("afforda_direct_apply") === "true";
  return directApply ? '/apply' : '/loans-landing';
};

export const handleBenefitsNavigation = (
  benefits: BenefitsSummary | null | undefined,
  navigate: NavigateFunction
) => {
  // Check if benefits is null, undefined, or an empty object
  if (!benefits || Object.keys(benefits).length === 0) {
    navigate('/getting-started');
  } else if (benefits.stage === 'full') {
    navigate('/benefits-summary');
  } else if (benefits.stage === 'estimate') {
    navigate('/quick-results');
  } else {
    // If benefits exists but doesn't have a valid stage, default to getting-started
    navigate('/getting-started');
  }
};
